/**
 * How long a launched chat's first turn stays replayable on the device that
 * launched it — the pending-prompt slot's TTL.
 *
 * A launch writes its record before the chat exists: the row appears only
 * when the mounted thread's first request lands. Inside this window a launch
 * with no chat row may still be starting (another tab, a slow navigation, a
 * reload that replays the slot); after it, nothing can start that run any
 * more. Anything that treats "no chat row" as "never ran" must wait it out.
 */
export const CHAT_LAUNCH_HANDOFF_TTL_MS = 10 * 60 * 1000

/** True once a launch recorded at `launchedAt` can no longer start its run. */
export function isLaunchHandoffExpired(
  launchedAt: number,
  now: number
): boolean {
  return now - launchedAt >= CHAT_LAUNCH_HANDOFF_TTL_MS
}
